<h1 mat-dialog-title *ngIf="!atWelcome" i18n>First Steps</h1>
<div mat-dialog-content>
  <div *ngIf="atWelcome">
    <!-- <div class="languageOptions">
      <mat-form-field>
        <mat-select
          value="{{ _session.getCurrentLocale() }}"
          placeholder="Language (Sprache)"
          #languageSelect
          (selectionChange)="changeLanguageVersion(languageSelect.value)"
        >
          <mat-option value="de">German (Deutsch)</mat-option>
          <mat-option value="en">English (Englisch)</mat-option>
        </mat-select>
      </mat-form-field>
    </div> -->
    <h1 class="greeting" i18n>
      <span class="toolNameSpan">Welcome</span> to the Video convOERter!
    </h1>
    <img
      class="logo"
      src="assets/oer-logo-4.png"
      height="130"
      width="130"
      alt="Logo"
    />
    <p class="welcomeText" i18n>
      This web app allows you to easily convert existing videos into Open Educational Resources (OER).
    </p>
    <div class="oerInfos">
      <a
        href="https://creativecommons.org/about/program-areas/education-oer/"
        target="_blank"
        i18n
        i18n-href
        >What is OER?</a
      >
    </div>

    <mat-list style="margin-top: 0; padding-top: 0">
      <h2 style="margin-bottom: 0; margin-top: 0.8rem" i18n>How it works</h2>
      <mat-list-item class="autoHeight">
        <mat-icon mat-list-icon>video_library</mat-icon>
        <div mat-line i18n>Video Overview</div>
        <div class="allowWrap" mat-line i18n>
          The Video convOERter analyzes your video content and helps manage licensing and attribution.
        </div>
      </mat-list-item>
      <mat-list-item class="autoHeight">
        <mat-icon mat-list-icon>account_tree</mat-icon>
        <div mat-line i18n>Decide Yourself</div>
        <div class="allowWrap" mat-line i18n>
          For each video, <i>you</i> can decide to replace it, mark it as your
          own work or exclude it from the overall license.
        </div>
      </mat-list-item>
      <mat-list-item class="autoHeight">
        <mat-icon mat-list-icon>movie_filter</mat-icon>
        <div mat-line i18n>Find Replacements</div>
        <div class="allowWrap" mat-line i18n>
          If you decide to replace a video, you can search through large
          collections of Creative Commons licensed videos to find suitable
          replacements.
        </div>
      </mat-list-item>
      <mat-list-item class="autoHeight">
        <mat-icon mat-list-icon>lock</mat-icon>
        <div mat-line i18n>Local Processing</div>
        <div class="allowWrap" mat-line i18n>
          Your video content is processed locally and not
          sent to any external server.
        </div>
      </mat-list-item>
      <mat-list-item class="autoHeight">
        <mat-icon mat-list-icon color="accent">auto_awesome</mat-icon>
        <div mat-line i18n>Automatic References & License</div>
        <div class="allowWrap" mat-line i18n>
          When all videos have been processed, you can save the modified version
          with all video sources and license notices included.
        </div>
      </mat-list-item>
    </mat-list>

    <mark i18n
      >Please note that you have to either be the copyright owner or have
      permission from all copyright owners of all content to publish
      it as OER.</mark
    >
    <p i18n>
      When you are ready, you can start with the video module.
    </p>
    <div>
      <button
        mat-raised-button
        color="primary"
        (click)="startModule()"
        #startButton
        cdkFocusInitial
      >
        Start!
      </button>
    </div>
  </div>

  <mat-horizontal-stepper
    #stepper
    linear
    *ngIf="!atWelcome"
    labelPosition="bottom"
    [formGroup]="stepperFormGroup"
    (selectionChange)="onStepChange($event)"
  >
    <mat-step
      label="Choose Video"
      i18n-label
      state="chooseFile"
      [stepControl]="stepperFormGroup.get('chosenFile')"
    >
      <h3 i18n>Select the video you want to convert into an OER</h3>
      <h5 i18n>Supported formats are {{ getAllVideoFormats() }}.</h5>
      <app-import-file (file-import)="onFileImport($event)"></app-import-file>
      <br /><br />
      <div>
        <button
          [disabled]="!stepperFormGroup.get('chosenFile').valid"
          mat-stroked-button
          color="primary"
          matStepperNext
          i18n
        >
          Next
        </button>
      </div>
    </mat-step>

    <mat-step
      label="Enter Name"
      i18n-label
      state="enterUserName"
      [stepControl]="stepperFormGroup.get('userName')"
    >
      <h3 i18n>Enter your name</h3>
      <h5 i18n>
        This name will be included in the resulting license disclaimer.
      </h5>
      <mat-form-field (keydown.enter)="stepper.next()">
        <mat-label i18n>Your full name</mat-label>
        <input
          matInput
          i18n-placeholder
          placeholder="John Doe"
          formControlName="userName"
        />
      </mat-form-field>
      <div>
        <button mat-button matStepperPrevious i18n>Back</button>
        <button
          [disabled]="!stepperFormGroup.get('userName').valid"
          mat-stroked-button
          color="primary"
          matStepperNext
          i18n
        >
          Next
        </button>
      </div>
    </mat-step>

    <mat-step
      i18n-label
      label="Enter Target License"
      state="enterTargetLicense"
      [stepControl]="stepperFormGroup.get('targetLicense')"
    >
      <h3 i18n>Choose a license for the resulting OER</h3>
      <h5 i18n>
        For general information about open licenses visit
        <a href="https://creativecommons.org/" target="_blank"
          >creativecommons.org</a
        >
      </h5>

      <mat-form-field style="width: 100%">
        <mat-label i18n>Choose the targeted license</mat-label>
        <mat-select formControlName="targetLicense" required>
          <mat-option *ngFor="let license of licenses" [value]="license">
            {{ getLicenseShortName(license) }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <br />

      <div *ngIf="stepperFormGroup.get('targetLicense').value">
        <span i18n>Full name: </span>
        <i>{{
          getLicenseFullName(stepperFormGroup.get("targetLicense").value)
        }}</i>
        <br />
        <a
          [href]="getLicenseURL(stepperFormGroup.get('targetLicense').value)"
          target="_blank"
          i18n
          >More Info about this license</a
        >
      </div>
      <br />
      <div>
        <button mat-button matStepperPrevious i18n>Back</button>
        <button
          [disabled]="!stepperFormGroup.get('targetLicense').valid"
          mat-stroked-button
          color="primary"
          matStepperNext
          i18n
        >
          Next
        </button>
      </div>
    </mat-step>

    <mat-step
      label="Enter Legal Disclaimer"
      i18n-label
      state="enterLegalText"
      [stepControl]="stepperFormGroup.get('disclaimerSlideText')"
    >
      <h3 i18n>Edit the generated disclaimer</h3>
      <h5>
        <span i18n>This disclaimer will be included in the resulting OER.</span>
        <br />
        <span i18n>You can edit it to your liking.</span>
      </h5>
      <mat-form-field style="width: 100%">
        <mat-label i18n>Disclaimer Text</mat-label>
        <textarea
          matInput
          rows="5"
          i18n-placeholder
          placeholder="Please enter the text on the legal disclaimer slide"
          formControlName="disclaimerSlideText"
          style="height: auto"
        ></textarea>
      </mat-form-field>
      <div>
        <button mat-button matStepperPrevious i18n>Back</button>
        <button mat-stroked-button color="primary" matStepperNext i18n>
          Next
        </button>
      </div>
    </mat-step>

    <mat-step label="Additional Options" i18n-label state="additionalOptions">
      <h3 i18n>Additional Options</h3>
      <h5 i18n>
        This feature helps classify video content to suggest replacement options automatically.
      </h5>
      <br />
      <mat-slide-toggle #autoClassifyToggle
        ><h4 i18n>Auto-recognize content</h4></mat-slide-toggle
      >
      <p *ngIf="autoClassifyToggle.checked" class="toggleDescText" i18n>
        If you select a video and choose to search for a replacement, the tool
        will automatically generate possible search terms and start the video
        search with those.
      </p>
      <p *ngIf="!autoClassifyToggle.checked" class="toggleDescText" i18n>
        The tool will not automatically search for suggested search terms when
        you choose to search for a replacement video.
      </p>
      <br />
      <button mat-button matStepperPrevious i18n>Back</button>
      <button
        mat-button
        mat-raised-button
        color="primary"
        (click)="processAdditionalOptions(autoClassifyToggle.checked)"
        i18n
      >
        Finish
      </button>
    </mat-step>

    <ng-template matStepperIcon="chooseFile">
      <mat-icon>video_file</mat-icon>
    </ng-template>
    <ng-template matStepperIcon="enterUserName">
      <mat-icon>person</mat-icon>
    </ng-template>
    <ng-template matStepperIcon="enterTargetLicense">
      <mat-icon>gavel</mat-icon>
    </ng-template>
    <ng-template matStepperIcon="enterLegalText">
      <mat-icon>assignment_late</mat-icon>
    </ng-template>
    <ng-template matStepperIcon="additionalOptions">
      <mat-icon>settings</mat-icon>
    </ng-template>
  </mat-horizontal-stepper>
</div> 